const precioRenderer = vm => (data, type, row) => {
    if (row.productos && row.productos.length > 0 && row.productos[0].precio != null) {
        return vm.GLOBAL.FORMATO_MONEY_BASIC(row.productos[0].precio);
    }
    return "-";
};

const impuestoRenderer = vm => (data, type, row) =>
    vm.GLOBAL.FORMATO_MONEY_BASIC(row.impuesto_total);

const ventaRenderer = vm => (data, type, row) =>
    vm.GLOBAL.FORMATO_MONEY(row.venta_total);

export { precioRenderer, impuestoRenderer, ventaRenderer };